import React from 'react';
import PropTypes from 'prop-types';
import LocaleText from '../../LocaleText';

class DyeableParts extends React.Component {
    renderPart(part) {
        const key = part.name;
        const isActivePart = this.props.activePart === key;
        const classes = ['menu__item'];

        if (isActivePart) {
            classes.push('menu__item--active');
        }

        return (
            <li className={classes.join(' ')} key={key}>
                <span className="label" onClick={() => this.props.setActivePart(key)}>
                    <LocaleText textKey={key} />
                </span>
            </li>
        );
    }

    render() {
        const { parts } = this.props;
        return (
            <div className="submenu__row part-selection">
                <ul className="menu">
                    {Object.keys(parts).map(key => this.renderPart(parts[key]))}
                </ul>
            </div>
        );
    }
}

DyeableParts.propTypes = {
    parts: PropTypes.object.isRequired,
    activePart: PropTypes.string,
    setActivePart: PropTypes.func.isRequired,
};

DyeableParts.defaultProps = {
    activePart: null,
};

export default DyeableParts;
